import { ErrorBase } from './base';

export class DuplicateImportModuleError extends ErrorBase {
	constructor(msg?: string) {
		super(`Duplicate import module error!\n ${msg}`);
	}
}
